





































































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import {State, Getter, Action, Mutation, namespace} from 'vuex-class'
import {mapGetters, mapActions} from 'vuex'
import _ from 'lodash'
import {mask} from 'vue-the-mask'
import {IRegisterFormData} from '@/store/modules/views/register/states'
import {IRegisterStatus} from '@/store/modules/views/register/actions'
import {CountryCode, getCountryCode} from '@/services/CountryCode'
import HttpRequest from '@/services/HttpRequestService'
import {UserStatus} from '@/services/userInterface'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import moment from 'moment'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import { IUser } from '@/store/modules/views/user/states'
// import CustomMap from "@/components/CustomMap.vue";

@Component({
  directives: {
    mask,
  },
})
export default class Signup extends VueExtendedBaseComponent {
  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  get fieldValidate() {
    return this.formInstant.validate()
  }

  get age() {
    const age = this.diffDate(this.date)
    const year = Math.floor(age)
    const month = Math.floor((age - year) * 12)
    return `อายุ ${ year ? year + 'ปี ' : '' }${ month }เดือน`
  }

  private valid = false
  private showMap = false
  private sign = ''
  private prefix = ''
  private firstName = ''
  private lastName = ''
  private phoneNumber = ''
  private cid = ''
  private lineId = ''
  private countryCode = {
    code: 'th',
    name: 'Thailand (ไทย)',
    dialCode: 66,
    phoneFormat: '081 234 5678',
  }
  private countryCodeList: CountryCode = getCountryCode()
  private password = ''
  private passwordValidate = false
  private repassword = ''
  private message = ''
  private DOB = ''
  private activePicker = null
  private date = null
  private menu = false
  private loading = false
  private snackbar = false
  private hiddenEmailInput = false
  private map = {
    lat: 0,
    lon: 0,
  }
  private id = ''
  private location: IRegisterFormData['address'] = {address: ''}
  private address = ''

  @Getter('register/getUserId')
  private getUserId!: string

  @Getter('components/prefixNames')
  private prefixNames: string[]

  @Getter('userprofile/getProfile')
  private profile!: any

  get invalidateInput() {
    return _.some(
        [
          this.validateInputFromType('phone', this.phoneNumber, true),
          this.validateInputFromType('text', this.address, true),
          this.validateInputFromType('number', this.map.lat.toString()),
          this.validateInputFromType('number', this.map.lat.toString()),
          this.validateInputFromType('cid', this.cid),
        ],
        (item) => item !== true,
    )
  }

  get logo() {
    return process.env.VUE_APP_BASEURL + '/' + process.env.VUE_APP_LOGO_LOGIN
  }

  get route() {
    return _.includes(this.$route.fullPath, 'success') || _.includes(this.$route.fullPath, 'otp-verify')
  }

  get checkPassAndRepassMatch() {
    return (
        this.repassword === this.password ||
        'The Re-Password confirmation does not match.'
    )
  }

  get isPasswordValid() {
    return this.passwordValidate
  }

  set isPasswordValid(status: boolean) {
    this.passwordValidate = status
  }

  get mask() {
    const phone = _.find(
        this.countryCodeList.contries,
        {dialCode: this.countryCode.dialCode},
    )
    return phone ? _.split(phone.phoneFormat, new RegExp('[0-9]')).join('#') : ''
  }

  @Action('register/PostRegisterData')
  private postRegisterData!: (
      registerData: IRegisterFormData,
  ) => Promise<IRegisterStatus>

  private doSearch(item: any, queryText: string) {
    return (
        _.filter(item, (res, key) => {
          return _.includes(_.lowerCase(item[key]), _.lowerCase(queryText))
        }).length > 0
    )
  }

  private requireInput(value) { return value !== '' || 'จำเป็นต้องกรอก' }

  private getFormData() {
    return {
      idCard: this.cid,
      lineId: this.lineId,
      phone: this.phoneNumber.match(/\S+/g).join(''),
      prefix: this.prefix,
      firstname: this.firstName,
      lastname: this.lastName,
      birthdate: this.date,
      map: this.map,
      address: {address: this.address, ...this.location},
      status: "",
      sign: this.sign,
    }
  }

  private changeDateType() {
    this.menu = false
  }

  private async submitRegisterForm() {
    const data = this.getFormData()
    if (!data.sign) {
      this.snackbar = true
      this.message = 'กรุณาเซ็นชื่อ'
      this.loading = false
      return false
    }
    const validate = this.formInstant.validate()
    if (validate) {
      try {
        this.loading = true
        if (this.id) {
          await HttpRequestServiceWithToken.put(
            `${process.env.VUE_APP_API_URL}/v1/authentication/${this.id}`,
            data,
          )
        } else {
          await this.postRegisterData(data)
        }
        // this.message = 'เข้าสู่ระบบเรียบร้อย'
        // this.snackbar = true
        // this.loading = false
        setTimeout(() => this.$router.push(`/redirect`), 500)
      } catch (error) {
        this.snackbar = true
        this.message = error.message
        console.log('error', this.message)
        setTimeout(() => {
          this.loading = false
        }, 2000)
      }
    } else {
      return false
    }
  }

  @Watch('cid')
  @Watch('date')
  @Watch('phoneNumber')
  private async getExistUser() {
    if (_.every(
      [
        this.validateInputFromType('phone', this.phoneNumber, true),
        this.validateInputFromType('date', this.date),
        this.validateInputFromType('cid', this.cid),
      ], (item) => item === true,
    )) {
      await HttpRequestServiceWithToken.get(
        `${process.env.VUE_APP_API_URL}/v1/authentication/${this.cid}/${this.phoneNumber}/${this.date}`,
        {},
        (res: IUser) => {
          if (res._id) {
            this.prefix = res.prefix
            this.firstName = res.firstname
            this.lastName = res.lastname
            this.id = res._id
          }
        },
      )
    }
  }

  @Watch('menu')
  private birthdate(val) {
    if (val) {
      setTimeout(() => (this.activePicker = 'YEAR'))
    }
  }

  @Watch('profile', {deep: true})
  private handleChangeProfile() {
    if (this.profile._id) {
      this.$router.push('/main/patient')
      return
    }
  }

  private async mounted() {
    this.handleChangeProfile()
    const line = this.$store.getters['userprofile/getLine']
    this.lineId = line.userId
    this.showMap = true
    // if (this.$route.query.invited) {
    //   try {
    //     const invitedId = this.$route.query.invited
    //     const url =  process.env.VUE_APP_BASEURL + `/v2/invited/${invitedId}`
    //     const result = await HttpRequest.get(url, {})
    //     const status = result.userData.status
    //     const userId = result.userData._id
    //     if (status === UserStatus.REQUIRE_INFORMATION) {
    //       this.hiddenEmailInput = true
    //       this.email = result.userData.email
    //     } else if (status === UserStatus.VERIFYOTP) {
    //       this.$router.push(`/signup/${userId}/otp-verify`)
    //     } else {
    //       this.updateSnackbar({txt: 'Link was not found or You have already activate.', type: 'error'})
    //     }
    //   } catch (error) {
    //     this.updateSnackbar({txt: 'Link was not found or You have already activate.', type: 'error'})
    //   }
    // }
  }
}
